module.exports = __webpack_public_path__ + "img/tetradi.e5d0cdad.svg";